export enum LinkReleaseTriggerAction {
  CONTEXT_MENU = 'context menu',
  SEARCH_BOX = 'search box',
  NO_ACTION = 'no action'
}
